<template>
  <div class="nerser">
    <!-- 宽度为100%的图片 -->
    <div>
      <img src="../../assets/banner.png" class="imgs" />
    </div>
    <!-- <img src="../../assets/statistics/myMessage.png" alt=""> 
            <span class="back" v-for="(iem,ind) in list" :key="ind">{{iem.content}}</span>
        -->
    <div class="flex-container">
      <div class="left">
        <ul class="ulr">
          <li
            v-for="(item, index) in navigation"
            :class="[typeOf === index ? 'purple-active' : 'bg-purple']"
            @click="switchStyle(index)"
          >
            <i :class="item.icon"></i> {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="right">
        <div v-if="typeOf === 0">
          <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane :label="item.name" :name="item.id" v-for="(item,index) in tabActive" :key="index">
                                    
                            </el-tab-pane>
                        </el-tabs> -->
          <div class="container">
            <img
              src="../../assets/statistics/10992.png"
              alt="image description"
              class="image"
            />
            <p
              class="text"
              style="line-height: 38px; color: #098cff; max-width: 120px"
            >
              我要发言
            </p>
            <p
              v-if="list.length > 0"
              style="
                font-size: 18px;
                color: #000;
                font-weight: bold;
                max-width: 122px;
                margin-left: 20px;
              "
            >
              猜你想问
            </p>
            <div class="words" v-if="list.length > 0">
              <p v-for="(item, index) in list" :key="index">
                {{ item.content }}
              </p>
            </div>
          </div>
          <div class="hotWords"></div>

          <el-input
            type="textarea"
            placeholder="使用过程中有任何不便，请告诉我吧~"
            v-model="textarea"
            :rows="15"
            show-word-limit
            @keyup.native="sensitiveFilter"
          >
          </el-input>
          <button type="button" class="btn" @click="confirm(1)">
            提交信息
          </button>
        </div>
        <div v-if="typeOf === 1">
          <div class="container">
            <img
              src="../../assets/statistics/10992.png"
              alt="image description"
              class="image"
            />
            <p
              class="text"
              style="line-height: 38px; color: #098cff; max-width: 120px"
            >
              我要发言
            </p>
            <p
              v-if="list.length > 0"
              style="
                font-size: 18px;
                color: #000;
                font-weight: bold;
                max-width: 122px;
                margin-left: 20px;
              "
            >
              猜你想问
            </p>
            <div class="words" v-if="list.length > 0">
              <p v-for="(item, index) in list" :key="index">
                {{ item.content }}
              </p>
            </div>
          </div>

          <el-input
            type="textarea"
            placeholder="需要其他的学习功能，可以悄悄告诉我~"
            v-model="textarea1"
            :rows="15"
            show-word-limit
            @keyup.native="sensitiveFilter"
          >
          </el-input>
          <button type="button" class="btn" @click="confirm(1)">
            提交信息
          </button>
        </div>
        <div v-if="typeOf === 2">
          <div
            v-if="readMember.length > 0"
            style="height: 500px; overflow: auto"
          >
            <el-collapse accordion>
              <el-collapse-item
                v-for="(en, sindex) in readMember"
                :key="sindex"
              >
                <template slot="title">
                  亲爱的用户：已收到您的.....
                  <!-- <i class="header-icon el-icon-info"></i> -->
                </template>
                <div>我提交：{{ en.readOpinionFeedback.message }}</div>
                <div style="color: red">回复</div>
                <div>{{ en.message }}</div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div v-else>
            <el-empty
              :image-size="300"
              :image="require('../../assets/statistics/Examination.png')"
              description="您还没有收到消息...."
            ></el-empty>
          </div>
        </div>
      </div>
    </div>
    <div class="feedback">
      <!--  -->
    </div>

    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      width="300px"
      :showClose="false"
      :close-on-click-modal="false"
      center
    >
      <img
        class="dia-img"
        src="../../assets/index/feedbackSuccess.png"
        alt=""
      />
      <span class="sdfe">反馈成功</span>
      <p class="pices">我们已收到您的信息，敬请期待</p>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <button class="confirmButton" @click="confirm(2)">我知道了</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  submitFeedback,
  getWords,
  getFeedbackList,
  sensitiveness,
} from "@/api/home/nav";
export default {
  data() {
    return {
      infor: "",
      typeOf: 0,
      activeName: "0",
      imageHeight: "350px",
      tabActive: [
        { name: "我的建议", id: "0" },
        { name: "我的想法", id: "1" },
      ],
      list: [],
      navigation: [
        { icon: "el-icon-chat-line-square", name: "我的建议" },
        { icon: "el-icon-s-opportunity", name: "我的想法" },
        { icon: "el-icon-s-comment", name: "我的回复" },
      ],
      textarea: "",
      textarea1: "",
      centerDialogVisible: false,
      source: true,
      readMember: [],
      SensitiveArr: [],
    };
  },
  created() {
    let infor = JSON.parse(sessionStorage.getItem("userInfo"));
    if (infor !== null) {
      this.infor = infor;
    }
    getWords().then((res) => {
      this.list = res.data;
    });
    this.querySensitiveWords();
  },

  methods: {
    querySensitiveWords() {
      sensitiveness().then((res) => {
        res.data.forEach((item) => this.SensitiveArr.push(item.content));
      });
    },
    handleClick(tab, event) {},
    sensitiveFilter(e) {
      for (var i = 0; i < this.SensitiveArr.length; i++) {
        // 创建一个正则表达式
        var r = new RegExp(this.SensitiveArr[i], "ig");
        e.target.value = e.target.value.replace(r, "*");
        e.target.value = e.target.value.replace(/\s+/g, "");
        if (this.typeOf === 0) this.textarea = e.target.value;
        if (this.typeOf === 1) this.textarea1 = e.target.value;
      }
    },
    confirm(e) {
      if (e === 1) {
        let text = "";
        if (this.typeOf === 0) {
          if (this.textarea === "") {
            this.$message.error("请输入内容！");
            return;
          }
          console.log(
            this.textarea,
            this.textarea.indexOf("*"),
            this.textarea.indexOf("*") !== -1
          );
          if (this.textarea.indexOf("*") !== -1) {
            this.$message.error("请规范用词 不可包含*号！");
            return;
          }
          text = this.textarea;
        }
        if (this.typeOf === 1) {
          if (this.textarea1 === "") {
            this.$message.error("请输入内容！");
            return;
          }
          if (this.textarea1.indexOf("*") !== -1) {
            this.$message.error("请规范用词 不可包含*号！");
            return;
          }
          text = this.textarea1;
        }
        let data = {
          memberId: this.infor.memberId, //用户编号
          message: text, //内容
          type: this.typeOf, //类型 0我的建议 1我的想法
        };
        submitFeedback(data).then((response) => {
          this.centerDialogVisible = true;
        });
      } else {
        this.textarea = "";
        this.textarea1 = "";
        this.centerDialogVisible = false;
      }
    },
    switchStyle(index) {
      this.typeOf = index;

      if (index === 2) {
        let data = {
          memberId: this.infor.memberId,
        };
        // this.infor.memberId
        getFeedbackList(data).then((res) => {
          this.readMember = res.rows;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nerser {
  height: 100vh;
  /* 使容器高度等于viewport的高度 */
  display: flex;
  flex-direction: column;
}
.imgs {
  display: block;
  max-width: 100%;
  object-fit: fill;
  object-fit: contain;
  object-fit: cover;
  object-fit: none;
  object-fit: scale-down;
}
.sefer {
  width: 3px;
  height: 20px;
  background: #2e81f4;
  display: inline-block;
  vertical-align: middle;
}
.flex-container {
  display: flex;
  flex-grow: 1;
  /* 让该元素自适应剩余高度 */
  .left {
    width: 200px;
    flex-basis: 200px;
    background: #f7f8fa;
  }
  .right {
    flex-grow: 1;
    background-image: url("../../assets/background.png");
    background-size: 100% 100%;
    padding: 20px 70px 0 70px;
    /* background: yellowgreen; */
  }
}
.container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;

  .words {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    p {
      margin: 7px;
      color: #098cff;
    }
  }
}
.image {
  margin-right: 10px;
  width: 70px;
  height: 70px;
}
.ulr {
  width: 100%;
  margin-top: 10px;
}

.purple-active {
  width: 100%;
  height: 70px;
  color: #098cff;
  line-height: 70px;
  text-align: center;
  font-size: 17px;
  background: #cfe8fe;
}

.bg-purple {
  width: 100%;
  height: 70px;
  color: #565656;
  line-height: 70px;
  text-align: center;
  font-size: 17px;
}

.bg-purple:hover {
  color: #2e81f4;
}

.conle {
  width: 100%;
  height: 160px;

  .back {
    color: #2e81f4;
    background: #e1edfe;
    padding: 5px 15px;
    display: inline-block;
    border-radius: 30px;
    margin: 30px 15px 0 0;
  }
}

.feedback {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
}

::v-deep .el-textarea__inner {
  background: #f9f8fd;
}

.btn {
  color: #ffffff;
  width: 140px;
  height: 45px;
  font-size: 16px;
  background: #396fe4;
  border: none;
  margin-top: 50px;
  border-radius: 10px;
  float: right;
  margin-right: 50px;
}

::v-deep .el-tabs__item {
  font-size: 16px !important;
}

::v-deep .el-tabs__item.is-active {
  font-size: 18px !important;
}

.dia-img {
  margin: 10px auto 0;
  width: 100px;
  height: 100px;
  display: block;
}

.sdfe {
  text-align: center !important;
  color: #2d8dff;
}

.pices {
  font-size: 15px;
}

::v-deep .el-dialog {
  display: flex;
  display: -ms-flex;
  /* 兼容IE */
  flex-direction: column;
  -ms-flex-direction: column;
  /* 兼容IE */
  margin: 0 !important;
  border-radius: 20px !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

::v-deep .el-dialog .el-dialog__body {
  max-height: 100%;
  flex: 1;
  -ms-flex: 1 1 auto;
  /* 兼容IE */
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
  font-size: 18px;
}

::v-deep .el-dialog__wrapper {
  /*隐藏ie和edge中遮罩的滚动条*/
  overflow: hidden;
}

::v-deep .customClass {
  background: #2d92ff;
  box-sizing: border-box;

  border: 1px solid #ffffff;

  .el-dialog__header {
    padding: 0 !important;
  }
}

.confirmButton {
  width: 193px;
  height: 50px;
  border: none;
  border-radius: 10px;
  color: #ffffff;
  font-size: 18px;
  background: linear-gradient(to right, #2d85ff, #2da5ff, #2dbeff);
}
</style>